module.exports = __webpack_public_path__ + "static/media/minus-octagon.a22010f7.svg";